export default __webpack_public_path__ + "static/media/Heaven's Wol Do.603cb2e2.jpg";